import moment from 'moment-timezone';

export const TIMED_SALE_TIME_ZONE = 'America/New_York';
export const TIMED_SALE_CLOSE_HOUR = 15;
export const TIMED_SALE_START_HOUR = 10;

const THURSDAY = 4;

export const TIMED_SALE_SCHEDULE_OPTIONS = [
  { value: 'next_week', label: 'Next week', weekOffset: 1 },
  { value: 'plus2_week', label: '+2 weeks', weekOffset: 2 },
  { value: 'plus3_week', label: '+3 weeks', weekOffset: 3 },
  { value: 'plus4_week', label: '+4 weeks', weekOffset: 4 },
];

export const getTimedSaleClosingMoment = (weekOffset, now = new Date()) => {
  return moment
    .tz(now, TIMED_SALE_TIME_ZONE)
    .startOf('week')
    .add(weekOffset, 'weeks')
    .day(THURSDAY)
    .hour(TIMED_SALE_CLOSE_HOUR)
    .minute(0)
    .second(0)
    .millisecond(0);
};

export const getTimedSaleWindowFromOption = (option, now = new Date()) => {
  const scheduleOption = TIMED_SALE_SCHEDULE_OPTIONS.find(item => item.value === option);
  if (!scheduleOption) {
    return null;
  }

  const end = getTimedSaleClosingMoment(scheduleOption.weekOffset, now);
  const start = end.clone().hour(TIMED_SALE_START_HOUR);

  return {
    start,
    end,
    startDate: start.format('YYYY-MM-DD'),
    endDate: end.format('YYYY-MM-DD'),
    startUnix: start.unix(),
    endUnix: end.unix(),
  };
};

const normalizeUnixTimestamp = value => {
  const timestamp = Number(value);
  return Number.isFinite(timestamp) && timestamp > 0 ? timestamp : null;
};

export const getTimedSaleEndUnix = publicData => {
  return (
    normalizeUnixTimestamp(publicData?.auctionEndUnix) ||
    normalizeUnixTimestamp(publicData?.auctionEndTime)
  );
};

export const isActiveTimedSaleListing = (publicData, nowMs = Date.now()) => {
  const endUnix = getTimedSaleEndUnix(publicData);
  return publicData?.isAuction === true && !!endUnix && endUnix * 1000 > nowMs;
};

export const formatTimedSaleClosingLabel = (intl, closingMoment) => {
  const dateLabel = intl.formatDate(closingMoment.toDate(), {
    timeZone: TIMED_SALE_TIME_ZONE,
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });

  return `${dateLabel}, 3:00 p.m. ET`;
};

export const getTimedSaleScheduleOptions = (intl, now = new Date()) => {
  return TIMED_SALE_SCHEDULE_OPTIONS.map(option => {
    const closingMoment = getTimedSaleClosingMoment(option.weekOffset, now);

    return {
      value: option.value,
      label: `${option.label} — ${formatTimedSaleClosingLabel(intl, closingMoment)}`,
    };
  });
};
